import { makeStyles, tokens } from "@microsoft/shifts-ui-core";

export const usePanelHeaderStyles = makeStyles({
  toolbar: {
    justifyContent: "space-between",
    height: "60px"
  },
  toolbarGroup: {
    display: "flex"
  },
  actionButton: {
    marginRight: tokens.spacingHorizontalM
  },
  dividerContainer: {
    height: "100%",
    display: "flex",
    alignItems: "center"
  },
  divider: {
    paddingLeft: tokens.spacingHorizontalNone,
    paddingRight: tokens.spacingHorizontalNone,
    height: "24px"
  },
  cancelButton: {
    marginLeft: tokens.spacingHorizontalXS
  },
  headerTitle: {
    fontWeight: tokens.fontWeightBold,
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalMNudge,
    // These aren't in tokens
    lineHeight: "24px",
    fontSize: "18px"
  }
});
